import { Lightning } from '@lightningjs/sdk'
import { Images } from '../../constants/paths'
import { getAsset } from '../../utils/image'
import { NAVIGATION_POINTERS_Z_INDEX } from './NavigationPointers'

export const enum Direction {
  Up = 'up',
  Right = 'right',
  Down = 'down',
  Left = 'left',
}

const ARROW_SIZE = 104

export class ArrowButton extends Lightning.Component {
  private _direction: Direction

  static _template() {
    return {
      collision: true, // Needed for mouse detection
      w: ARROW_SIZE,
      h: ARROW_SIZE,
      zIndex: NAVIGATION_POINTERS_Z_INDEX + 1,

      Arrow: {
        texture: Lightning.Tools.getSvgTexture(
          getAsset(Images.ARROW_POINTER),
          ARROW_SIZE,
          ARROW_SIZE,
        ),
      },
    }
  }

  set direction(v: Direction) {
    this._direction = v

    let rotation = 0

    if (v === Direction.Up) {
      rotation = Math.PI
    } else if (v === Direction.Left) {
      rotation = 90 * (Math.PI / 180)
    } else if (v === Direction.Right) {
      rotation = 270 * (Math.PI / 180)
    }

    // The rotation of the texture needs to be done on a child, in this case the Arrow, otherwise, the click detection gets screwed up
    this.arrow.patch({
      rotation,
    })
  }

  get arrow() {
    return this.tag('Arrow')
  }

  _handleUnhover() {}

  _handleHover() {
    this.fireAncestors('$arrowFocusByHover', this.ref)
  }

  _handleClick() {
    this.fireAncestors(`$${this._direction}Movement`)
  }
}
